import { CustomerDetailPage } from '@/features/customers/routes/CustomerDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers/customer/$id')({
  component: CustomerDetailPage,
});
